// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-apps_next_src_app_home_models_configurator_ts-apps_next_src_app_home_services_studio_-c1abf6":"36db6371f70981aa","apps_next_src_app_link_link_module_ts":"590001866fca71f9","apps_next_src_app_home_home_module_ts":"0fe95edbb16dc90f"}[chunkId] + ".js";
};